//Bar chart Data

export var barChartSingle = [
  {
    "name": "Germany",
    "value": 894
  },
  {
    "name": "USA",
    "value": 500
  },
  {
    "name": "France",
    "value": 720
  },
  {
    "name": "Australia",
    "value": 650
  }
];

export var barChartmulti = [
  {
    "name": "Germany",
    "series": [
      {
        "name": "2010",
        "value": 730
      },
      {
        "name": "2011",
        "value": 894
      }
    ]
  },

  {
    "name": "USA",
    "series": [
      {
        "name": "2010",
        "value": 787
      },
      {
        "name": "2011",
        "value": 827
      }
    ]
  },

  {
    "name": "France",
    "series": [
      {
        "name": "2010",
        "value": 500
      },
      {
        "name": "2011",
        "value": 580
      }
    ]
  },
  {
    "name": "Australia",
    "series": [
      {
        "name": "2010",
        "value": 600
      },
      {
        "name": "2011",
        "value": 650
      }
    ]
  }
];


//Pie chart Data

export var pieChartSingle = [
  {
    "name": "Germany",
    "value": 894
  },
  {
    "name": "USA",
    "value": 500
  },
  {
    "name": "France",
    "value": 720
  }
];

export var pieChartmulti = [
  {
    "name": "Germany",
    "series": [
      {
        "name": "2010",
        "value": 730
      },
      {
        "name": "2011",
        "value": 894
      }
    ]
  },

  {
    "name": "USA",
    "series": [
      {
        "name": "2010",
        "value": 787
      },
      {
        "name": "2011",
        "value": 827
      }
    ]
  },

  {
    "name": "France",
    "series": [
      {
        "name": "2010",
        "value": 500
      },
      {
        "name": "2011",
        "value": 580
      }
    ]
  }
];


//Line Chart

export var lineChartSingle = [
  {
    "name": "Germany",
    "value": 894
  },
  {
    "name": "USA",
    "value": 500
  },
  {
    "name": "France",
    "value": 720
  }
];

export var lineChartMulti = [
  {
    "name": "Germany",
    "series": [
      {
        "name": "2010",
        "value": 700
      },
      {
        "name": "2011",
        "value": 750
      },
      {
        "name": "2012",
        "value": 775
      },
      {
        "name": "2013",
        "value": 725
      },
      {
        "name": "2014",
        "value": 750
      },
      {
        "name": "2015",
        "value": 800
      },
      {
        "name": "2016",
        "value": 860
      }
    ]
  },

  {
    "name": "USA",
    "series": [
      {
        "name": "2010",
        "value": 650
      },
      {
        "name": "2011",
        "value": 800
      },
      {
        "name": "2012",
        "value": 705
      },
      {
        "name": "2013",
        "value": 750
      },      
      {
        "name": "2014",
        "value": 850
      },
      {
        "name": "2015",
        "value": 875
      },      
      {
        "name": "2016",
        "value": 730
      }
    ]
  },

  {
    "name": "France",
    "series": [
      {
        "name": "2010",
        "value": 660
      },
      {
        "name": "2011",
        "value": 720
      },
      {
        "name": "2012",
        "value": 680
      },
      {
        "name": "2013",
        "value": 675
      },      
      {
        "name": "2014",
        "value": 700
      },
      {
        "name": "2015",
        "value": 680
      },      
      {
        "name": "2016",
        "value": 690
      }
    ]
  }
];

//Area Chart

export var areaChartSingle = [
  {
    "name": "Germany",
    "value": 894
  },
  {
    "name": "USA",
    "value": 500
  },
  {
    "name": "France",
    "value": 720
  }
];

export var areaChartMulti = [
  {
    "name": "Germany",
    "series": [
      {
        "name": "2010",
        "value": 700
      },
      {
        "name": "2011",
        "value": 670
      },
      {
        "name": "2012",
        "value": 825
      },
      {
        "name": "2013",
        "value": 725
      },
      {
        "name": "2014",
        "value": 750
      },
      {
        "name": "2015",
        "value": 800
      },
      {
        "name": "2016",
        "value": 860
      }
    ]
  },

  {
    "name": "USA",
    "series": [
      {
        "name": "2010",
        "value": 650
      },
      {
        "name": "2011",
        "value": 800
      },
      {
        "name": "2012",
        "value": 705
      },
      {
        "name": "2013",
        "value": 750
      },      
      {
        "name": "2014",
        "value": 850
      },
      {
        "name": "2015",
        "value": 875
      },      
      {
        "name": "2016",
        "value": 730
      }
    ]
  },
];

